/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Rentenversicherungsnr2Inputs */



/**

* @param {_Field_Rentenversicherungsnr2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_rentenversicherungsnr2 = /** @type {((inputs?: _Field_Rentenversicherungsnr2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Rentenversicherungsnr2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Rentenversicherungsnummer")
});
export { _field_rentenversicherungsnr2 as "_field_rentenVersicherungsNr" }